module.exports = __webpack_public_path__ + "img/gauge-simple-low.a1ec86f9.svg";